<template>
  <div>
    <el-dialog title="余额提现" :visible="visible" width="480px" top="8vh" append-to-body custom-class="withdraw-dialog account-ui-dialog"
      :close-on-click-modal="false" :before-close="close" @open="open">
      <div v-loading="loading">
        <p v-if="failed" class="withdraw-error">提现信息加载失败 <el-button type="text" @click="load">重试</el-button></p>
        <section class="withdraw-method">
          <strong>提现方式</strong>
          <el-select v-if="accounts.length" v-model="selectedIndex" aria-label="提现方式" :disabled="busy || loading || walletLoading" @change="loadWallet">
            <el-option v-for="(account, index) in accounts" :key="account.type_id + ':' + account.id" :value="index" 
             :label="account.bank_name + '（' + account.bank_card + '）'" />
          </el-select>
          <div v-else-if="!loading && !failed" class="withdraw-card-guide">
            <template v-if="authentication !== 1"><span>添加银行卡前需完成实名认证</span><el-button type="text" :disabled="busy" @click="goRealName">去实名认证</el-button></template>
            <el-button v-else type="text" :disabled="busy" @click="manageCards">暂无银行卡，添加银行卡</el-button>
          </div>
        </section>
        <section class="withdraw-content">
          <label for="withdraw-amount">请输入提现金额（最低{{ info.withdraw_min == null ? '--' : info.withdraw_min }}元）</label>
          <div class="withdraw-amount-row"><span>￥</span><el-input id="withdraw-amount" v-model="amount" placeholder="100.00" inputmode="decimal" :disabled="busy || loading" /><el-button type="text" :disabled="busy || loading || failed" @click="amount = String(user.account || 0)">全部提现</el-button></div>
          <div v-if="isWallet" class="withdraw-wallet" v-loading="walletLoading">
            <p v-if="walletFailed">钱包信息加载失败 <el-button type="text" @click="loadWallet">重试</el-button></p>
            <p v-else>{{ selected.bank_name }}钱包余额：{{ wallet.amount == null ? '--' : wallet.amount }} <el-button type="text" :disabled="busy" @click="loadWallet">刷新</el-button></p>
            <el-button type="text" :disabled="walletLoading || walletFailed || busy" @click="openTrade">前往{{ selected.bank_name }}支付交易大厅</el-button><span>(提币成功后请前往交易大厅操作)</span>
          </div>
          <div class="withdraw-info-row withdraw-fee"><span>实际到账：{{ received }}</span><span>手续费：{{ fee.value }}{{ fee.percent ? '%' : '元' }}</span></div>
          <div class="withdraw-info-row"><span>可提现金额：{{ user.account == null ? '--' : user.account }}</span><span>不可提现金额：{{ user.blocked_money == null ? '--' : user.blocked_money }}</span></div>
          <div class="withdraw-info-row"><span>提现审核中：{{ info.blocked == null ? '--' : info.blocked }}</span><el-button type="text" @click="details">详情</el-button></div>
          <p v-if="selected && selected.type_id === 4" class="withdraw-fee">汇率 USDT:CNY 1:{{ info.usdt_rate }}，USDT 实际到账：{{ usdtReceived }}</p>
          <el-button class="withdraw-submit" :loading="busy" :disabled="loading || failed || !selected || walletLoading || walletFailed" @click="submit">立即提现</el-button>
          <p class="withdraw-limits">您今日还可提现{{ info.withdraw_num == null ? '--' : info.withdraw_num }}次 {{ info.withdraw_min == null ? '--' : info.withdraw_min }}元起提 单笔限额{{ info.withdraw_max == null ? '--' : info.withdraw_max }}元</p>
        </section>
      </div>
    </el-dialog>
    <bank-cards-dialog :visible.sync="cardsVisible" />
  </div>
</template>

<script>
import { apiUserInfo, apiGetRealName, apiWithdrawInfo, apiWithdraw, apiRechargeInfo, apiRechargeSuInfo, apiThirdPayUserinfo, apiCheckSafePwd, apiSuPayCheck, apiSuPayAdd } from '@/utils/requestapis'
import BankCardsDialog from '../settings/BankCardsDialog.vue'

export default {
  name: 'WithdrawDialog',
  components: { BankCardsDialog },
  props: { visible: Boolean },
  data() {
    return { loading: false, failed: false, busy: false, user: {}, info: {}, authentication: 0,
      accounts: [], selectedIndex: 0, amount: '', tradeTypes: [], wallet: {}, walletLoading: false, walletFailed: false, cardsVisible: false }
  },
  computed: {
    selected() { return this.accounts[this.selectedIndex] || null },
    isWallet() { return this.selected && (this.selected.type_id === 72 || this.tradeTypes.includes(this.selected.type_id)) },
    fee() {
      const channel = this.selected || {}, info = this.info
      let value = Number(info.withdraw_fee) || 0, mode = Number(info.withdraw_fee_mode) || 0, tiers = info.withdraw_custom_fee
      if (Number(info.user_withdraw_fee) > 0) {
        value = Number(info.user_withdraw_fee); mode = Number(info.user_withdraw_fee_mode) || 0
      } else if (channel.withdraw_fee_type != null && Number(channel.withdraw_fee_type) === 0 && Number(channel.withdraw_fee_type0_rate) > 0) {
        value = Number(channel.withdraw_fee_type0_rate); mode = 1
      } else if (Number(channel.withdraw_fee_type) === 1) {
        mode = 2; tiers = []
        for (let i = 1; i <= 6; i++) {
          if (Number(channel['withdraw_fee_type' + i + '_rate']) > 0) tiers.push({ start_money: Number(channel['withdraw_fee_type' + i + '_amount']) || 0, withdraw_rate: Number(channel['withdraw_fee_type' + i + '_rate']) })
        }
      }
      if (mode === 2) {
        value = 0
        const rates = Array.isArray(tiers) ? tiers.slice().sort((a, b) => Number(a.start_money) - Number(b.start_money)) : []
        for (const tier of rates) if (Number(this.amount) >= Number(tier.start_money)) value = Number(tier.withdraw_rate) || 0
      }
      return { value, percent: mode > 0 }
    },
    received() {
      const amount = Number(this.amount) || 0
      const charge = this.fee.percent ? amount * this.fee.value / 100 : this.fee.value
      return (Math.max(0, Math.round((amount - charge) * 100)) / 100).toFixed(2)
    },
    usdtReceived() { return Number(this.info.usdt_rate) > 0 ? (Number(this.received) / Number(this.info.usdt_rate)).toFixed(4) : '--' }
  },
  watch: { cardsVisible(value) { if (!value && this.visible) this.load() } },
  methods: {
    open() { this.amount = ''; return this.load() },
    close(done) {
      if (this.busy || this.loading || this.walletLoading || this.cardsVisible) return
      this.amount = ''; this.$emit('update:visible', false); done()
    },
    async load() {
      this.loading = true; this.failed = false; this.accounts = []; this.user = {}; this.info = {}; this.walletFailed = false
      try {
        const [user, info, real, recharge] = await Promise.all([apiUserInfo({}), apiWithdrawInfo({}), apiGetRealName({}), apiRechargeInfo({})])
        if (!user || !info || !real || ![0, 1, '0', '1'].includes(real.authentication) || !recharge) { this.failed = true; return }
        this.user = user; this.info = info; this.authentication = Number(real.authentication)
        this.tradeTypes = (((recharge.type_arr || {}).tradeJumpArr) || []).map(Number)
        this.accounts = [].concat(Array.isArray(info.card_list) ? info.card_list : [], Array.isArray(info.third_list) ? info.third_list : []).map(account => {
          const type = account.type_id == null ? 1 : Number(account.type_id)
          return { ...account, type_id: type, bank_name: type === 9 ? 'C币账户' : account.bank_name, bank_card: type === 9 ? account.wallet_url : account.bank_card }
        }).filter(account => account.bank_card != null && String(account.bank_card).trim() !== '')
        this.selectedIndex = 0
        await this.loadWallet()
      } catch (_) { this.failed = true }
      finally { this.loading = false }
    },
    async loadWallet() {
      this.wallet = {}; this.walletFailed = false
      if (!this.isWallet) return
      this.walletLoading = true
      try {
        const result = await (this.selected.type_id === 72 ? apiRechargeSuInfo({}) : apiThirdPayUserinfo({ pay_type: this.selected.type_id }))
        if (!result || (this.selected.type_id === 72 && Number(result.state) !== 200)) { this.walletFailed = true; return }
        this.wallet = result
      } catch (_) { this.walletFailed = true }
      finally { this.walletLoading = false }
    },
    manageCards() {
      if (this.busy || this.loading || this.failed || this.authentication !== 1) return
      this.cardsVisible = true
    },
    async goRealName() {
      if (this.busy || this.loading || this.failed || this.walletLoading || this.cardsVisible || this.authentication === 1) return
      this.busy = true
      try {
        await this.$router.push({ path: '/settings', query: { realName: '1' } })
        this.$emit('update:visible', false)
      } catch (_) { this.$message.warning('无法打开实名认证，请重试') }
      finally { this.busy = false }
    },
    details() {
      this.$alert('1. 充值返现的资金仅可抵扣合约利息，不能直接提现。\n2. 提现冻结金额为提现审核中的金额，不能用于操盘。', '详情', { confirmButtonText: '知道了', customClass: 'account-confirm' }).catch(() => {})
    },
    async openTrade() {
      if (!this.isWallet || this.walletFailed || this.walletLoading || this.busy) return
      this.busy = true
      try {
        const answer = await this.$prompt('请输入安全密码', '安全密码验证', { inputType: 'password', inputValidator: value => !!value || '请输入安全密码', confirmButtonText: '确认', cancelButtonText: '取消', customClass: 'account-confirm' })
        const result = await (this.tradeTypes.includes(this.selected.type_id) ? apiCheckSafePwd({ password: answer.value, pay_type: this.selected.type_id }) : this.wallet.is_add_pass ? apiSuPayCheck({ password: answer.value }) : apiSuPayAdd({ password: answer.value }))
        if (result === 0 || result === undefined) return
        const url = (result || {}).jump_url || (result || {}).url
        if (result && (result.is_blank || result.status) && /^https?:\/\//i.test(url)) this.$emit('trade', url)
        else this.$message.warning((result || {}).msg || '无法打开交易大厅')
      } catch (_) { /* Cancel or shared request interceptor error. */ }
      finally { this.busy = false }
    },
    validAmount() {
      if (!this.selected) { this.$message.warning('请选择提现方式'); return false }
      const amount = Number(this.amount)
      if (![this.user.account, this.info.withdraw_min, this.info.withdraw_max, this.info.withdraw_num].every(value => value != null && value !== '' && Number.isFinite(Number(value)))) { this.$message.warning('提现信息不完整，请刷新后重试'); return false }
      if (!/^\d+(\.\d{1,2})?$/.test(String(this.amount)) || !Number.isFinite(amount) || amount <= 0) { this.$message.warning('请输入正确的提现金额，最多两位小数'); return false }
      if (amount > Number(this.user.account)) { this.$message.warning('提现金额超过可提现余额'); return false }
      if (amount < Number(this.info.withdraw_min) || amount > Number(this.info.withdraw_max)) { this.$message.warning('提现金额超出单笔限额'); return false }
      if (Number(this.info.withdraw_num) <= 0) { this.$message.warning('今日提现次数已用完'); return false }
      if (Number(this.received) <= 0) { this.$message.warning('提现金额不足以支付手续费'); return false }
      return true
    },
    async submit() {
      if (this.loading || this.failed || this.busy || this.walletLoading || this.walletFailed || !this.validAmount()) return
      this.busy = true
      try {
        const answer = await this.$prompt('请输入6位提现密码', '提现密码验证', { inputType: 'password', inputValidator: value => /^\d{6}$/.test(value || '') || '请输入6位数字提现密码', confirmButtonText: '确认提现', cancelButtonText: '取消', customClass: 'account-confirm' })
        const result = await apiWithdraw({ id: this.selected.id, amount: this.amount, bankName: this.selected.bank_name, bankCard: this.selected.bank_card, pay_password: answer.value, type: this.selected.type_id })
        if (result === 0 || result === undefined) return
        this.$message.success('提现申请已提交，请等待审核')
        this.amount = ''; this.$emit('submitted'); this.$emit('update:visible', false)
      } catch (_) { /* Cancel or shared interceptor error. Keep amount on failure. */ }
      finally { this.busy = false }
    }
  }
}
</script>

<style>
.withdraw-dialog { max-width: calc(100vw - 40px); border-radius: 10px; overflow: hidden; }
.withdraw-dialog .el-dialog__header { padding: 24px; text-align: center; }
.withdraw-dialog .el-dialog__title { color: var(--theme-text); font-size: 22px; font-weight: 600; }
.withdraw-dialog .el-dialog__body { height: auto; max-height: 72vh; overflow-y: auto; padding: 0; word-break: normal; background: var(--theme-bg) !important; }
.withdraw-dialog .withdraw-method { padding: 24px; background: var(--theme-panel); display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 14px; color: var(--theme-text); font-size: 18px; }
.withdraw-dialog .el-select { width: 65%; }
.withdraw-dialog .withdraw-card-guide { display:flex; flex-direction:column; align-items:flex-end; gap:8px; font-size:14px; color:var(--theme-muted); }
.withdraw-dialog .withdraw-content { padding: 24px; color: var(--theme-text); background: var(--theme-panel); font-size: 18px; }
.withdraw-dialog .withdraw-amount-row { display: flex; align-items: center; gap: 8px; margin-top: 22px; padding-bottom: 16px; border-bottom: 1px solid var(--theme-border); }
.withdraw-dialog .withdraw-amount-row > span { font-size: 30px; }
.withdraw-dialog .withdraw-amount-row .el-input { flex: 1; }
.withdraw-dialog .withdraw-amount-row .el-input__inner { background: transparent; border: 0; color: var(--theme-text); font-size: 26px; }
.withdraw-dialog .el-input__inner::placeholder { color: var(--theme-muted); }
.withdraw-dialog .withdraw-amount-row .el-button, .withdraw-dialog .withdraw-info-row .el-button { color: var(--theme-danger); font-size: 16px; padding: 0; }
.withdraw-dialog .withdraw-info-row { display: flex; justify-content: space-between; flex-wrap: wrap; gap: 12px; margin-top: 18px; color: var(--theme-muted); font-size: 16px; }
.withdraw-dialog .withdraw-fee, .withdraw-dialog .withdraw-error { color: var(--theme-danger); }
.withdraw-dialog .withdraw-submit { width: 100%; min-height: 64px; margin-top: 38px; font-size: 22px; background: #d84c55; color: #fff; border: 0; border-radius: 0; }
.withdraw-dialog .withdraw-submit.is-disabled { background: #d84c55; color: #fff; opacity: .5; }
.withdraw-dialog .withdraw-limits { margin: 32px 0 0; color: var(--theme-muted); font-size: 18px; line-height: 1.8; }
.withdraw-dialog .withdraw-wallet { margin-top: 20px; color: var(--theme-muted); font-size: 16px; }
.withdraw-dialog .withdraw-error { padding: 16px 24px; }
@media (max-width: 600px) { .withdraw-dialog .withdraw-content, .withdraw-dialog .withdraw-method { padding: 18px; } .withdraw-dialog .withdraw-info-row { font-size: 14px; } }
</style>
